export const OrderConfirmationLandingPageTemplate = {
    slots: ['SlbPlaceOrderContainerSlot'],
};